module.exports = __webpack_public_path__ + "img/Layer_2.e7438c6d.png";